import React, { useState } from 'react';
import { Store, Users, TrendingUp, Heart, FileText, Send } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { sendFormData } from '../utils/sendForm';
import Notification from './Notification';
import './Franchise.css';

const Franchise = () => {
  const [notification, setNotification] = useState({ show: false, type: 'success', title: '', message: '' });
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const onSubmit = async (data) => {
    try {
      await sendFormData({ type: 'franchise', ...data }, 'franchise');
      reset();
      setNotification({
        show: true,
        type: 'success',
        title: 'Candidature envoyée !',
        message: 'Merci pour votre intérêt ! Nous étudions votre dossier et vous recontacterons rapidement.'
      });
      setTimeout(() => {
        setNotification({ show: false, type: 'success', title: '', message: '' });
      }, 8000);
    } catch (e) {
      console.error('Franchise send error', e);
      setNotification({
        show: true,
        type: 'error',
        title: 'Erreur lors de l\'envoi',
        message: 'Une erreur est survenue. Veuillez réessayer plus tard.'
      });
    }
  };

  const franchiseFeatures = [
    {
      icon: <Store size={40} />,
      title: "Concept éprouvé",
      description: "Un concept unique dans l'univers des desserts et bubble tea avec une identité forte"
    },
    {
      icon: <Users size={40} />,
      title: "Formation complète",
      description: "Formation initiale et accompagnement continu pour garantir votre succès"
    },
    {
      icon: <TrendingUp size={40} />,
      title: "Croissance rapide",
      description: "Marché en forte expansion avec un potentiel de développement important"
    },
    {
      icon: <Heart size={40} />,
      title: "Communauté passionnée",
      description: "Rejoignez une famille d'entrepreneurs partageant les mêmes valeurs"
    }
  ];

  return (
    <section className="franchise section">
      <div className="container">
        <div className="franchise-header">
                        <h1 className="section-title">Devenir Franchisé Pinky Cloud</h1>
          <p className="section-subtitle">
                          Rejoignez l'aventure Pinky Cloud et créez votre propre univers magique des desserts !
          </p>
        </div>

        {/* Avantages de la franchise */}
        <div className="franchise-features">
                      <h2>Pourquoi choisir Pinky Cloud ?</h2>
          <div className="features-grid">
            {franchiseFeatures.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Formulaire de candidature */}
        <div className="franchise-form-section">
          <div className="franchise-info">
            <div className="process-steps">
              <h3>Le processus en 4 étapes</h3>
              <div className="steps">
                <div className="step">
                  <span className="step-number">1</span>
                  <div>
                    <strong>Candidature</strong>
                    <p>Envoyez-nous votre dossier de candidature</p>
                  </div>
                </div>
                <div className="step">
                  <span className="step-number">2</span>
                  <div>
                    <strong>Entretien</strong>
                    <p>Rencontre avec notre équipe</p>
                  </div>
                </div>
                <div className="step">
                  <span className="step-number">3</span>
                  <div>
                    <strong>Formation</strong>
                    <p>Formation complète sur le concept</p>
                  </div>
                </div>
                <div className="step">
                  <span className="step-number">4</span>
                  <div>
                    <strong>Ouverture</strong>
                    <p>Lancement de votre restaurant</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="franchise-form-container">
            <form onSubmit={handleSubmit(onSubmit)} className="franchise-form">
              <input type="text" name="website" style={{display:'none'}} aria-hidden="true" tabIndex="-1" />
              <h3>
                <FileText size={24} />
                Dossier de candidature
              </h3>

                <div className="form-section">
                  <h4>Informations personnelles</h4>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">Prénom *</label>
                      <input
                        type="text"
                        {...register('firstName', { required: 'Prénom requis' })}
                        className="form-input"
                        placeholder="Votre prénom"
                      />
                      {errors.firstName && <span className="form-error">{errors.firstName.message}</span>}
                    </div>

                    <div className="form-group">
                      <label className="form-label">Nom *</label>
                      <input
                        type="text"
                        {...register('lastName', { required: 'Nom requis' })}
                        className="form-input"
                        placeholder="Votre nom"
                      />
                      {errors.lastName && <span className="form-error">{errors.lastName.message}</span>}
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">Email *</label>
                      <input
                        type="email"
                        {...register('email', { 
                          required: 'Email requis',
                          pattern: {
                            value: /^\S+@\S+$/i,
                            message: 'Email invalide'
                          }
                        })}
                        className="form-input"
                        placeholder="votre.email@exemple.com"
                      />
                      {errors.email && <span className="form-error">{errors.email.message}</span>}
                    </div>

                    <div className="form-group">
                      <label className="form-label">Téléphone *</label>
                      <input
                        type="tel"
                        {...register('phone', { required: 'Téléphone requis' })}
                        className="form-input"
                        placeholder="06 12 34 56 78"
                      />
                      {errors.phone && <span className="form-error">{errors.phone.message}</span>}
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <h4>Projet de franchise</h4>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">Ville souhaitée *</label>
                      <input
                        type="text"
                        {...register('city', { required: 'Ville requise' })}
                        className="form-input"
                        placeholder="Paris, Lyon, Marseille..."
                      />
                      {errors.city && <span className="form-error">{errors.city.message}</span>}
                    </div>

                    <div className="form-group">
                      <label className="form-label">Budget disponible *</label>
                      <select
                        {...register('budget', { required: 'Budget requis' })}
                        className="form-select"
                      >
                        <option value="">Choisir</option>
                        <option value="80000-120000">80 000€ - 120 000€</option>
                        <option value="120000-180000">120 000€ - 180 000€</option>
                        <option value="180000+">Plus de 180 000€</option>
                      </select>
                      {errors.budget && <span className="form-error">{errors.budget.message}</span>}
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="form-label">Expérience dans la restauration</label>
                    <select
                      {...register('experience')}
                      className="form-select"
                    >
                      <option value="">Sélectionner</option>
                      <option value="none">Aucune expérience</option>
                      <option value="basic">Expérience client</option>
                      <option value="management">Management en restauration</option>
                      <option value="owner">Propriétaire de restaurant</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label className="form-label">Motivations et projet *</label>
                    <textarea
                      {...register('motivation', { required: 'Motivation requise' })}
                      className="form-textarea"
                      placeholder="Expliquez vos motivations, votre projet, vos objectifs..."
                      rows="4"
                    />
                    {errors.motivation && <span className="form-error">{errors.motivation.message}</span>}
                  </div>
                </div>

                <button type="submit" className="btn btn-primary btn-large franchise-btn">
                  <Send size={20} />
                  Envoyer ma candidature
                </button>

                <p className="form-disclaimer">
                  En soumettant ce formulaire, vous acceptez d'être recontacté par notre équipe franchise 
                  et que vos données soient utilisées dans le cadre de l'étude de votre candidature.
                </p>
              </form>
          </div>
        </div>
      </div>
      
      <Notification
        show={notification.show}
        type={notification.type}
        title={notification.title}
        message={notification.message}
        onClose={() => setNotification({ show: false, type: 'success', title: '', message: '' })}
      />
    </section>
  );
};

export default Franchise; 